export enum WeighingType {
  FULL = 'FULL', EMPTY = 'EMPTY', BETWEEN = 'BETWEEN'
}
